"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const design_system_1 = require("@zapier/design-system");
const common_utils_1 = require("@zapier/common-utils");
const FieldFocusContext_1 = require("./FieldFocusContext");
const Styles = common_utils_1.labelStyles(__filename, {
    root: (isMuted) => [
        {
            transitionDuration: design_system_1.Animation.transitionDuration,
            transitionProperty: 'opacity',
            transitionTimingFunction: 'ease',
        },
        common_utils_1.withModifier('muted', {
            opacity: isMuted ? 0.5 : 1.0,
        }),
    ],
});
const ExclusiveFieldFocus = (props) => {
    const { onBlur, onFocus, isMuted } = FieldFocusContext_1.useFieldFocusContext();
    return (common_utils_1.isolateComponent("div", { css: Styles.root(isMuted), onBlur: onBlur, onFocus: onFocus }, props.children));
};
exports.default = ExclusiveFieldFocus;
